import e from "./highrise1335.mjs";
import i from "./highrise1339.mjs";
import a from "./highrise1337.mjs";
function t(r) {
  return a(r) ? e(r, !0) : i(r);
}
export {
  t as default
};
